/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useTranslation } from 'react-i18next'
import { Icon, Message, MessageContent, MessageHeader, MessageItem, MessageList } from 'semantic-ui-react'
import { useQuery } from '@tanstack/react-query'
import useUser from '../Shared/UserProvider/useUser'
import { getPointOfSale } from '../../services/PointOfSale/PointOfSale.service'
import { isProviderAPos } from '../../services/Provider/Provider.service'
import { TIME } from '../../services/date.service'
import { NavigateToBillingFormButton } from './NavigateToBillingFormButton'

const PaymentAnomalyMessage = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data: pos} = useQuery({
        queryKey: ['pointofsales', user.getUserPos()?.id],
        queryFn: () => getPointOfSale(user.getUserPos()?.id),
        enabled: isProviderAPos(user.provider),
        staleTime: TIME.HOUR_IN_MS,
    })

    if (!pos || !pos.subscriptionStatus || pos.subscriptionStatus === 'active') {
        return null
    }

    return (
      <div css={css`
          margin: 1rem 0;
      `}>
          <Message
            icon
            attached
            color='orange'
            size={'small'}
          >
              <Icon name="warning sign"/>
              <MessageContent
                css={css`
                    white-space: pre-wrap;
                `}
              >
                  <MessageHeader>
                      {t('administration.billing.paymentAnomaly.title')}
                  </MessageHeader>
                  <p>{t('administration.billing.paymentAnomaly.message_1')}</p>
                  <MessageList>
                      <MessageItem>{t('administration.billing.paymentAnomaly.bullet_1')}</MessageItem>
                      <MessageItem>{t('administration.billing.paymentAnomaly.bullet_2')}</MessageItem>
                      <MessageItem>{t('administration.billing.paymentAnomaly.bullet_3')}</MessageItem>
                  </MessageList>
                  <p>{t('administration.billing.paymentAnomaly.message_2')}</p>
              </MessageContent>
          </Message>
          <NavigateToBillingFormButton label={t('administration.billing.paymentAnomaly.navigateToBillingFormButton')} />
      </div>
    )
}

export { PaymentAnomalyMessage }
